import React from "react";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Button } from "@chakra-ui/react";
import { getRiskReviewErrorMessage } from "../../utils/riskReviewFormatters";

const RiskReviewErrorState = ({ error, onRetry }) => {
  const status = error?.response?.status;
  const message =
    status === 403
      ? "You do not have access to this Risk Review function."
      : getRiskReviewErrorMessage(error);

  return (
    <Alert status={status === 403 ? "warning" : "error"} borderRadius="md" alignItems="flex-start">
      <AlertIcon />
      <AlertTitle>{status === 403 ? "Access denied" : "Unable to load"}</AlertTitle>
      <AlertDescription flex="1">{message}</AlertDescription>
      {onRetry ? (
        <Button size="sm" variant="outline" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </Alert>
  );
};

export default RiskReviewErrorState;
